import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-datasource';
import { APCourse } from '../../global/builders/ap_course_builder';
import { IAPCoursesDatasource } from '../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../../global/datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import { APCommandUrlServant } from '../../global/servants/ap_command_url_servant';

export interface ICourseGroup {
  id: number;
  program_slot: number;
}

angular.module('capability-ng-academic-planner').factory(
  'removeCourseFromTermAndAddCourseCommand',
  /* tslint:disable:parameters-max-number */
  function removeCourseFromTermAndAddCourseCommand(
    log: any,
    $http: ng.IHttpService,
    $rootScope: ng.IRootScopeService,
    ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    ngAPTermsDatasource: IAPTermsDatasource,
    ngAPCommandUrlServant: APCommandUrlServant,
    ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    ngAPCoursesDatasource: IAPCoursesDatasource,
    defineCommandORM: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngAPNotificationDelegate: INotificationDelegate
  ): ICommand {
    return defineCommandORM(
      'removeCourseFromTermAndAddCourseCommand',
      (
        deferred: ng.IDeferred<IQuery[]>,
        courseToRemove: any,
        courseToAdd: APCourse,
        programSlotToAdd: any,
        oldTerm: number,
        newTerm: number,
        courseNk: null | string | number = null,
        source: string = 'PLANNER'
      ): void => {
        const payload = {
          course_id: courseToRemove.course,
          term_id: oldTerm
        };

        const academicPlanUrl = ngAPCommandUrlServant.get('academicPlan');

        $http
          .delete(academicPlanUrl, {
            data: payload
          })
          .then((response: any) => {
            ngAPPlannedCoursesDatasource.del(courseToRemove.id);

            const slot = programSlotToAdd;
            const savePayload = {
              course_id: courseToAdd.id,
              term_id: newTerm,
              slot_id: _4.isEmpty(slot) || slot.slot < 1 || slot.isDevReq ? null : slot.id,
              course_nk: courseNk,
              source
            };

            $rootScope.$emit('my.planner.show.saving.message', newTerm);

            $http
              .post(academicPlanUrl, savePayload)
              .then((secondResponse: any) => {
                _4.each(response.data.conflict_course, (crse: APCourse) => {
                  ngAPCoursesDatasource.put(crse);
                });
                ngAPCoursesDatasource.write(secondResponse.data.course);
                ngAPPlannedCoursesDatasource.clear().write(secondResponse.data.planned_course);

                deferred.resolve(
                  QueryMediator.runQueries(
                    ngAPPlannedCoursesDatasource,
                    ngAPPlannedCourseGroupDatasource,
                    ngAPProgramSlotDatasource,
                    ngAPTermsDatasource
                  )
                );
              })
              .catch((error: any) => {
                ngAPNotificationDelegate.error(`failed to save course to term`);
                log.issue('failed to save course to term');
                deferred.reject(error.data);
              });
          })
          .catch((e: any) => {
            ngAPNotificationDelegate.error(`failed to save course to term`);
            log.issue('failed to save course group');
            deferred.reject(e);
          });
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/remove_course_from_term_and_add_course_command.ts